import BaseOnboardingService from "./baseOnboarding.service";

class UnavailabilityBodyLocationService extends BaseOnboardingService {
  constructor() {
    super("unavailability-bodyLocation");
  }
}

export default new UnavailabilityBodyLocationService();